<div class="page-title-box">
	<h1>{{title}}</h1>
    <ul class="bradcrumb">
      <li>{{title}}</li>
      <li><a routerLink="{{cancelLink}}" title="Surgery" class="only-link">Surgery</a></li>
      <li><a routerLink="/dashboard" title="Dashboard" class="dashboard">Dashboard</a></li>
    </ul>
  </div>
  
  <section class="container-fluid">
        <div class="row justify-content-md-center">
          <div class="col-xl-8 col-md-12 col-sm-12">
              <form [formGroup]="surgeryForm" autocomplete="off" novalidate (ngSubmit)="onSubmit()">
              <div class="card-wrape">
                    <div class="card-head">
                        <h4 class="left-text">{{title}}</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                          <div class="col-xl-6 col-md-6">
                              <div class="input-wrape" 
                              [class]="this.commonService.displayFieldCss(this.surgeryForm, 'name')">
                                  <mat-label><i>*</i> Name</mat-label>
                                    <mat-form-field appearance="outline">
                                      <input matInput #input 
                                          placeholder="Enter name" 
                                          formControlName="name" 
                                          (focusout)="
                                              checkUniqueSurgery(
                                              $event
                                              )
                                          "
                                          type="text">
                                  </mat-form-field>
                                  <mat-error *ngIf="this.surgeryForm.controls['name'].invalid && (this.surgeryForm.controls['name'].dirty || this.surgeryForm.controls['name'].touched)">
                                      {{getSurgeryNameError()}}
                                  </mat-error>
                              </div>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <div class="input-wrape" *ngIf="isCurate">
                              <mat-label><i>*</i> Is Approved?:</mat-label>
                              <mat-radio-group aria-label="Select an option" class="example-radio-group">
                                <mat-radio-button ngDefaultControl
                                  class="example-radio-button"
                                  formControlName="isApproved" 
                                  id="radio_yes"
                                  (click)="selectOption(false)"
                                  [value]="true" checked
                                >
                                  Approved</mat-radio-button>
                                <mat-radio-button ngDefaultControl
                                  class="example-radio-button"
                                  formControlName="isApproved" 
                                  id="radio_no"
                                  (click)="selectOption(true)"
                                  [value]="false"
                                >
                                  Map with others</mat-radio-button>
                              </mat-radio-group>
                            </div>
                          </div>
                          <div class="col-xl-6 col-md-6">
                            <div class="input-wrape" *ngIf="selectMapOption"
                              [class]="this.commonService.displayFieldCss(this.surgeryForm, 'mapWithOtherSurgery')">
                              <mat-label><i>*</i> Map With:</mat-label>
                              <div class="control-pad">
                                <ng-select [items]="surgeryNameList" formControlName="mapWithOtherSurgery"
                                  bindLabel="name" bindValue="id" labelForId="mapWithOtherSurgery"
                                  placeholder="Select surgery">
                                </ng-select>
                                <mat-error
                                  *ngIf="this.surgeryForm.controls['mapWithOtherSurgery'].invalid && (this.surgeryForm.controls['mapWithOtherSurgery'].dirty || this.surgeryForm.controls['mapWithOtherSurgery'].touched)">
                                  {{getMapWithSurgeryError()}}
                                </mat-error>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                    <div class="card-footer">
                        <button mat-raised-button class="btn" color="warn" routerLink="{{this.cancelLink}}" title="Cancel">Cancel</button>
                      <button mat-raised-button class="btn" [disabled]="disableSubmitBtn" type="submit" color="secoundary" title="{{buttonText}}">{{buttonText}}</button> 
                    </div>
                </div>
              </form>
          </div>
      </div>
  </section>